import React from 'react';
import { TextField, TextFieldProps, } from '@mui/material';

interface NumberInputProps extends Omit<TextFieldProps, 'type' | 'onFocus'> {
    onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

const NumberInput: React.FC<NumberInputProps> = ({
  onFocus,
  sx,
  ...props
}) => {
  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    e.target.select();
    onFocus?.(e);
  };

  return (
    <TextField
      type="number"
      onFocus={handleFocus}
      {...props}
      sx={{
        ...sx,
        '& .MuiOutlinedInput-root': {
          borderRadius: 2,
        },
        
      }}
    />
  );
};

export default NumberInput;

